import { Container, Row } from "reactstrap";
import Profit from "./Profit/Profit";
import TopSelling from "./TopSelling/TopSelling";
import LatestSales from "./LatestSales/LatestSales";
import SalesAnalytics from "./SalesAnalytics/SalesAnalytics";
import TopDealer from "./TopDealer/TopDealer";
import RecentSales from "./RecentSales/RecentSales";
import ConversionRate from "./ConversionRate/ConversionRate";
import TopCountries from "./TopCountries/TopCountries";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs";
import { Dashboard, Ecommerce } from "../../../utils/Constant";

const ContainerEcommerce = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Ecommerce} parent={Dashboard} />
      <Container fluid className="dashboard_ecommerce">
        <Row>
          <Profit />
          <TopSelling />
          <LatestSales />
          <SalesAnalytics />
          <TopDealer />
          <RecentSales />
          <ConversionRate />
          <TopCountries />
        </Row>
      </Container>
    </>
  );
};

export default ContainerEcommerce;
